<template>
   <svg fill="currentColor" viewBox="0 0 32 32">
      <path d="m13 24l-9-9l1.414-1.414L13 21.171L26.586 7.586L28 9L13 24z" />
   </svg>
</template>
